module.exports = __webpack_public_path__ + "img/goods_invoice.8ebaa83d.png";